import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider as MuiDateLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enIN } from 'date-fns/locale';
import type { ReactNode } from 'react';

/**
 * Wraps MUI X's date-adapter `LocalizationProvider` — required for any `@mui/x-date-pickers`
 * component (`DatePickerField`, `DateTimePicker`) to render. Named for the date-localization
 * concern specifically, distinct from MUI's generic `LocalizationProvider` export.
 *
 * <p>`adapterLocale={enIN}` matches the day-month-year convention `utils/dateUtils.ts` already
 * uses for every other date display in the app — without it, MUI X's pickers default to a
 * US-style format, which would read inconsistently next to the rest of the platform.</p>
 */
export function DateLocalizationProvider({ children }: { children: ReactNode }) {
  return (
    <MuiDateLocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enIN}>
      {children}
    </MuiDateLocalizationProvider>
  );
}
